import React from "react";
import { Alert, Card, Col, Row, Tag, Typography } from "antd";
import { APP_VERSION } from "../../../../Constant";

const { Text } = Typography;

interface VersionStatProps {
  label: string;
  value: string | null;
  matched?: boolean;
}

const VersionStat: React.FC<VersionStatProps> = ({ label, value, matched }) => {
  return (
    <div className="flex flex-col">
      <Text type="secondary" className="text-xs uppercase tracking-wide">
        {label}
      </Text>
      <span className="text-lg font-semibold flex items-center gap-2">
        {value ?? "—"}
        {matched !== undefined && (
          <Tag color={matched ? "green" : "red"}>
            {matched ? "Match" : "Mismatch"}
          </Tag>
        )}
      </span>
    </div>
  );
};

interface VersionOverviewCardProps {
  beVersion: string | null;
  versionsMatched: boolean;
}

export const VersionOverviewCard: React.FC<VersionOverviewCardProps> = ({
  beVersion,
  versionsMatched,
}) => {
  return (
    <Card size="small">
      <Row gutter={[24, 16]} align="middle">
        <Col xs={24} md={10}>
          <VersionStat
            label="Frontend Version"
            value={APP_VERSION}
            matched={versionsMatched}
          />
        </Col>
        <Col xs={24} md={10}>
          <VersionStat
            label="Backend Version"
            value={beVersion}
            matched={versionsMatched}
          />
        </Col>
        <Col xs={24} md={4} className="text-right">
          {versionsMatched ? (
            <Tag color="green" className="text-sm px-3 py-1">
              In Sync
            </Tag>
          ) : (
            <Tag color="red" className="text-sm px-3 py-1">
              Out of Sync
            </Tag>
          )}
        </Col>
      </Row>
      {!versionsMatched && (
        <Alert
          className="mt-4"
          type="warning"
          showIcon
          message="Frontend and backend versions do not match"
          description="Update the APP_VERSION constant in both client/src/Constant/config.ts and server/config.php to the same value before deploying."
        />
      )}
    </Card>
  );
};
